import API from '@/shared/plugins/Api/API'

class LogsCC extends API {
  constructor (id) {
    super(id)
    this.prefix = '/v1'
  }

  async getBuildLogs (appType, workerId, { start, end } = {}) {
    const params = {}
    if (start) params.start = start
    if (end) params.end = end
    const response = await this.request({
      method: 'get',
      url: `${this.prefix}/logs/${encodeURIComponent(appType)}/${encodeURIComponent(workerId)}`,
      params
    })
    return response?.logs ?? []
  }
}

export default LogsCC
